import { type CategoryDTO } from 'ecosystem'
import { createContext } from 'ui/lib/react-utils'

export interface SlideOutCategoriesDesktopContextState {
  currentTopCategory: CategoryDTO | null
  paths: {
    categories: string
  }
  menuCategoriesThumbnails?: boolean
  topNavSlideOutFeaturedCategories?: number
}

export const [SlideOutCategoriesDesktopProvider, useSlideOutCategoriesDesktop] =
  createContext<SlideOutCategoriesDesktopContextState>({
    name: 'MenuMultiColumnSlideOutCategoriesDesktop'
  })
